<template>
  
  <div>
    <x-grid :id="'formList'"
            :rowId="rowId"
            :pager-config="pagerConfig"
            :form-config="formConfig"
            :url="url"
            :columns="columns"
            :checkbox-config="checkboxConfig"
            :toolbar-config="toolbarConfig"
            :print-config="printConfig"
            :export-config="exportConfig"
            ref="grid"
            :cellClick="chooseRow"
            :cellDbClick="updateRow"
            @toolbar-addData="addRow"
            @toolbar-delData="delRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="edit()">编辑</vxe-button>
      </template>
    </x-grid>

    <!-- 详情页 -->
    <a-modal
        title="角色管理"
        centered
        :closable="false"
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        :width="1200"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm :rowId="editRowId"
                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </detailForm>
    </a-modal>


  </div>
</template>

<script>
import XGrid from '@/components/grid/XGrid';
import {GridMixin} from "@/utils/GridMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter";
import api from '@/services/api';
import {loadBaseCodeData} from "@/services/baseCodeSource";

console.info(fmt, loadBaseCodeData);//防止未用到报未定义错误 用到了可删除

import detailForm from "@/pages/web/comm/roleManage/roleManageDetail";
import {mapState} from "vuex";

//弹出层组件


const fac = XGrid.factory;

//列表接口
const url = api.comm.ROLE
//主键
const rowId = 'roleId';

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("roleNo", "角色编号", 140),
  fac.makeColumn("roleName", "角色名称", 140),
  fac.makeColumn("roleTypeName", "角色类型", 140),
  fac.makeColumn("belongDeptName", "所属部门", 140),
  fac.makeColumn("createUserName", "创建人", 100, 'center'),
  fac.makeColumn("createDate", "创建时间", 160, 'center'),
  fac.makeColumn("lastModifyUserName", "最后修改人", 100, 'center'),
  fac.makeColumn("lastModifyDate", "最后修改时间", 160, 'center'),
  fac.makeColumn("remark", "备注", 300),
]


// 预加载函数 用来加载 列表查询中的通用代码 或其他代码
const formConfig = fac.makeFormConfig(columns, [
  {field: 'roleNo'},
  {field: 'roleName'}
])


//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  export: true,
  import: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

export default {
  mixins: [GridMixin],
  components: {
    detailForm,
  },
  computed: {
    ...mapState('account', {currUser: 'user'}),
  },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
    }
  },
  methods: {
    add(){
      this.openEdit(0);
    },
    edit() {
      let rows = this.getRows();
      if (rows.length !== 1) {
        return this.$message.error('请选择一条数据');
      }
      this.editModalVisible = true;
      this.editRowId=rows[0].roleId
    },
  }
}
</script>

<style scoped>
</style>